import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import { InvoicesApisActionTypes } from './constants';
import { invoicesApiResponseSuccess, invoicesApiResponseError } from './actions';
import { APICore } from '../../helpers/api/apiCore';

const api = new APICore();

function* invoicesApis(action: any): SagaIterator {
    try {
        const filters = action.payload || {};
        const params: any = {};

        if (filters.franchiseId && filters.franchiseId !== 'all') {
            params.franchiseId = filters.franchiseId;
        }

        if (filters.year && filters.year !== 'all') {
            params.year = String(filters.year);
        }

        if (filters.month && filters.month !== 'all') {
            params.month = String(filters.month);
        }

        const response = yield call(() => api.get(`/subscriptions/invoices`, params));
        const data = response.data || response;
        yield put(invoicesApiResponseSuccess(InvoicesApisActionTypes.GET_INVOICES_APIS_DATA, data));
    } catch (error: any) {
        console.log(error, 'error---');
        yield put(
            invoicesApiResponseError(InvoicesApisActionTypes.GET_INVOICES_APIS_DATA, error.message || 'Something Went Wrong')
        );
    }
}

export function* watchInvoicesApis() {
    yield takeEvery(InvoicesApisActionTypes.GET_INVOICES_APIS_DATA, invoicesApis);
}

function* invoicesApisSaga() {
    yield all([fork(watchInvoicesApis)]);
}

export default invoicesApisSaga;
